export default {
  path: 'groups',
  name: 'Groups',
  component: () => import(/* webpackChunkName: "people" */ '../views/PeopleGroupsView.vue')
}
